module.exports = "/_next/static/images/0d57a40620b71390bb7fe7fe692ef725-Protect yourself_md.png";